<template>
  <div class="player-box">
    <div class="lh-header">
      <div class="bg-fff">
        <div class="logo-image"></div>
        <div class="view-tips">(视频课程不支持浏览器兼容模式，为观看正常切换为极速模式)</div>
      </div>
    </div>
    <div class="lh-play-wrap">
      <div class="lh-umain" :class="hiddenSide ? 'lh-umain-show' : ''">
        <div class="pr">
          <div
            id="right-side-box"
            class="lh-right-wrap"
            :class="hiddenSide ? 'hidden-to-side' : 'normal-show'"
          >
            <div class="lh-r-w-head">
              <div style="cursor:pointer" @click="whichOnclick('0')">
                <div class="icon-kc-menu">&nbsp;</div>
                <div class="right-title">课程目录</div>
                <div :class="clickThis === '0' ? 'icon24-kc-icon-left' : ''"></div>
              </div>
              <!-- <div style="cursor:pointer" @click="whichOnclick('1')">
                <div class="icon-kc-note"></div>
                <div class="right-title">关于课程</div>
                <div
                  :class="clickThis === '1' ? 'icon24-kc-icon-right' : ''"
                ></div>
              </div>-->
            </div>
            <div class="lh-r-body">
              <el-tabs type="border-card">
                <el-tab-pane label="目录">
                  <div style="margin-top:20px">
                    <el-collapse accordion v-model="activeName">
                      <el-collapse-item name="0">
                        <template slot="title">{{ courseCatalogue.name }}</template>
                        <div v-for="(item, index) in courseCatalogue.childKpoints" :key="index">
                          <div class="list-item-out-box">
                            <div class="item-out-border-left-box">
                              <div class="item-innner-border-left-box"></div>
                            </div>
                            <div class="item-innner-border-right-box">
                              <div class="item-innner-text-box" @click="toViewVideo(item.id)">
                                <div class="item-innner-text-triangle-box"></div>
                                <div
                                  class="item-innner-text-catalogue-box"
                                  :class="
                                    item.id === itemId
                                      ? 'inner-text-onview'
                                      : ''
                                  "
                                >
                                  第{{
                                  item.sort < 10
                                  ? "0".concat("", item.sort - 1)
                                  : item.sort - 1
                                  }}讲：{{ item.name }}
                                </div>
                              </div>
                              <div class="item-innner-text-right-box">
                                <div class="el-icon-video-camera-solid"></div>
                                <div class="course-duration">
                                  {{ item.courseMinutes }}分&nbsp;{{
                                  item.courseSeconds
                                  }}秒
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="评论">角色管理</el-tab-pane> -->
              </el-tabs>
            </div>
          </div>
          <div class="lh-play-box" :class="hiddenSide ? 'lh-play-box-show' : ''">
            <div class="lh-p-b-title">
              <div class="left-fl">
                <div class="curse-playing">
                  <div class="titleByBig">{{ childKpointsName }}</div>
                  <div class="course-item-index"></div>
                </div>
              </div>
            </div>
            <div class="video-pr" v-loading="dataLoading">
              <div
                class="aside-o-c-btn"
                :class="hiddenSide ? 'turn-raound-show' : ''"
                @click="changeToShow"
              ></div>
              <div v-loading="false" class="flash-play-wrap" id="flash-play-box">
                <iframe
                  id="cciframe_4FE82DBB17DBDEE4B463AB73BD4C026B"
                  ref="iframe"
                  :src="videoUrl"
                  frameborder="0"
                  height="100%"
                  allowfullscreen="true"
                  @load="iframeLoaded"
                  width="100%"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <iframe
      id="cciframe_4FE82DBB17DBDEE4B463AB73BD4C026B"
      :src="videoUrl"
      frameborder="0"
      height="100%"
      width="100%"
    ></iframe>-->
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { videoPlayer } from "vue-video-player";
import { getVidoPlayByUrl, getCourseDetail } from "../../utils/interface";
export default {
  components: {
    videoPlayer
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: '数字化 | 数字化课程 | 数字化转型课程 |工业企业数字化转型课程 |企业培训',
        },
        {
          // set meta
          name: "description",
          content: '专注于企业数字化转型课程的内容，帮助中小企业实现数字化转型升级。拥有丰富的课程资源、讲师资源，提供企业线上培训、新员工培训、在线培训考试、企业内训等服务，助力工业企业智能数字化转型。',
        },
      ],
    }
  },
  data() {
    return {
      videoUrl: "",
      clickThis: "0",

      curCourseId: "",
      itemId: "",
      dataLoading: true,
      courseBasicInfo: null,
      courseCatalogue: null,
      activeName: ["0"],

      hiddenSide: false,
      childKpointsName: "",
      parkHeight: "",

      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      metaTitle: "",
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor"
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.getParams();
    window.addEventListener("resize", this.handleResize);

    // window.innerHeight + "px" ||
    //   document.documentElement.clientHeight + "px" ||
    //   document.body.clientHeight + "px"
  },
  created() {
    this.vuexAllPark(false);
  },
  methods: {
    iframeLoaded() {
      console.log("0", this.$refs.iframe.contentWindow.document.img);
      const iframeDocument =
        // this.$refs.iframe.contentDocument ||
        this.$refs.iframe.contentWindow.document;
      const imgElements = iframeDocument.querySelectorAll("img");
      console.log("***", imgElements, iframeDocument);

      imgElements.forEach(img => {
        img.style.width = "100%"; // 修改图片宽度为100%
        img.style.height = "auto"; // 高度自动
      });
    },
    //监听窗口尺寸
    handleResize() {
      console.log("打印浏览窗口大小变化：", window.innerWidth);
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      let a = document.getElementById("right-side-box");
      let b = document.getElementById("flash-play-box");
      console.log("窗口宽度：", this.windowWidth);
      console.log("窗口高度：", this.windowHeight);
      a.style.height = this.windowHeight - 100 + "px";
      b.style.height = this.windowHeight - 150 + "px";

      console.log("a.style.width:", a.style.width);
      // b.style.width = this.windowWidth - a.style.width + "px"
    },
    ...mapMutations(["vuexAllPark"]),
    getParams() {
      this.courseItemId = this.$route.query.courseItemId;
    },

    queryVideoPlayer(id) {
      getVidoPlayByUrl(id).then(res => {
        this.videoUrl = `https://p.bokecc.com/playhtml.bo?vid=${res.data.videoUrl}&siteid=3EE2A0ED88CA5056&autoStart=true`;
      });
    },

    whichOnclick(val) {
      this.clickThis = val;
    },

    getParams() {
      this.curCourseId = this.$route.query.courseId;
      this.itemId = this.$route.query.courseItemId;
      this.childKpointsName = this.$route.query.itemName;
      this.getDetailByUuid(); //获取列表
      this.queryVideoPlayer(this.itemId); //正在播放
    },
    getDetailByUuid() {
      this.dataLoading = true;
      let api = getCourseDetail;
      api(this.curCourseId)
        .then(res => {
          if (res.data) {
            this.dataLoading = false;
            this.courseBasicInfo = res.data.course;
            this.metaTitle =res.data.course.name +"-人才服务-公共服务平台"
            this.courseCatalogue = res.data.courseKpoints[0];
            this.toViewVideo(this.itemId);
          }
        })
        .catch(() => {
          this.dataLoading = false;
        });
    },

    changeToShow() {
      this.hiddenSide = !this.hiddenSide;
    },
    toViewVideo(id) {
      if (!!id) {
        this.childKpointsName = this.courseCatalogue.childKpoints.find(
          ele => ele.id === id
        ).name;
        this.itemId = id;
        this.queryVideoPlayer(id);
      }
    }
  }
};
</script>
<style lang="less" scoped>
// /deep/ .flash-play-wrap body iframe {
//   img {
//     width: 100%;
//   }
// }
/deep/ .ccH5Poster img {
  width: 100%;
  height: 100%;
}

.player-box {
  height: 100vh;
  background: #1c1f21;
  .lh-header {
    position: relative;
    width: 100%;
    height: 60px;
    z-index: 99;
    display: block;

    .bg-fff {
      background: #000;
      position: fixed;
      width: 100%;
      height: 78px;
      z-index: 109;
      display: flex;

      .logo-image {
        background: url(../../assets/publicService/logo.png) no-repeat 100% 100%;
        width: 300px;
        height: 55px;
        vertical-align: middle;
      }
      .view-tips {
        color: #f2f2f2;
        font-size: 14px;
        position: relative;
        top: 31px;
        height: 21px;
      }
    }
  }

  .lh-play-wrap {
    background: url(../../assets/publicService/resourcePool/lh-black-bg.png)
      repeat-x 0 -3px;
    position: relative;
    z-index: 39;
    display: block;

    .lh-umain {
      padding: 0 10px;
      background: url(../../assets/publicService/resourcePool/black-bg.png)
        repeat 0 0;
      padding-bottom: 20px;
      .pr {
        position: relative;
        display: block;

        .lh-right-wrap {
          background: #fff;
          position: fixed;
          display: block;
          top: 78px;
          right: 10px;
          height: 89.2vh;
          width: 400px;
          z-index: 89;

          .lh-r-w-head {
            display: block;
            background: #2d50a1;
            height: 51px;
            position: relative;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .icon-kc-menu {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -1px -171px;
              cursor: pointer;
              position: absolute;
              left: 33px;
              top: 13px;
              height: 92px;
              width: 30px;
              text-align: center;
              overflow: hidden;
            }
            .right-title {
              color: #fff;
              font: 20px / 51px "Hiragino Sans GB", "Microsoft YaHei";
              margin-right: 198px;
            }

            .icon-kc-note {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -1px -207px;
              cursor: pointer;
              position: absolute;
              right: 138px;
              top: 13px;
              height: 92px;
              width: 30px;
              text-align: center;
              overflow: hidden;
            }

            .icon24-kc-icon-left {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -1px -245px;
              cursor: pointer;
              position: absolute;
              left: 71px;
              top: 38px;
              height: 26px;
              width: 30px;
              text-align: center;
              overflow: hidden;
            }

            .icon24-kc-icon-right {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -1px -245px;
              cursor: pointer;
              position: absolute;
              right: 95px;
              top: 38px;
              height: 26px;
              width: 30px;
              text-align: center;
              overflow: hidden;
            }
          }

          .lh-r-body {
            // height: 771px;
            overflow: hidden;
            position: relative;

            /deep/ .el-tabs--border-card {
              background: #fff;
              border: none;
              box-shadow: none;
              /* border: 1px solid #dcdfe6; */
              /* -webkit-box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04); */
              /* box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04); */
            }
            /deep/ .el-tabs__item {
              padding: 0 45px;
              height: 40px;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              line-height: 40px;
              display: inline-block;
              list-style: none;
              font-size: 14px;
              font-weight: 500;
              color: #303133;
              position: relative;
            }
            /deep/ .el-tabs__nav {
              white-space: nowrap;
              position: relative;
              -webkit-transition: -webkit-transform 0.3s;
              transition: -webkit-transform 0.3s;
              -o-transition: transform 0.3s;
              transition: transform 0.3s;
              transition: transform 0.3s, -webkit-transform 0.3s;
              transition: transform 0.3s, -webkit-transform 0.3s;
              /* float: left; */
              z-index: 2;
              margin-left: 20px;
              margin-top: 12px;
            }
            /deep/ .el-tabs--border-card > .el-tabs__header {
              background-color: #fff;
              border-bottom: 1px solid #2d50a1;
              margin: 0;
            }
            /deep/
              .el-tabs--border-card
              > .el-tabs__header
              .el-tabs__item.is-active {
              background-color: #fff;
              border-right-color: #2d50a1;
              border-left-color: #2d50a1;
              border-top: 1px solid #2d50a1;
              color: #2d50a1;
              font-size: 16px;
            }

            /deep/.el-collapse {
              border: none;
              // height: 671px;
              overflow: hidden;

              .el-collapse-item__header {
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                height: 29px;
                line-height: 48px;
                background-color: #fff;
                color: #555;
                cursor: pointer;
                border-bottom: none;
                font-size: 14px;
                font-weight: 500;
                transition: border-bottom-color 0.3s;
                outline: 0;
              }

              .el-collapse-item__header.is-active {
                border-bottom: 1px solid #e8e8e8;
              }

              .el-collapse-item__wrap {
                will-change: height;
                background-color: #fff;
                overflow: hidden;
                box-sizing: border-box;
                border-bottom: none;
                // margin-left: 15px;
                // border-left: 1px dotted #cccccc;
                // padding-left: 16px;

                .el-collapse-item__content {
                  padding-bottom: 0px;
                  font-size: 13px;
                  color: #555;
                  line-height: 1.769230769230769;

                  .list-item-out-box {
                    // height: 31px;
                    display: flex;
                    align-items: flex-end;
                    margin-top: 5px;
                    margin-bottom: 5px;
                    margin-left: 10px;

                    .item-out-border-left-box {
                      border-left: 1px dotted #cccccc;
                      height: 13px;
                      display: flex;
                      margin-bottom: 5px;
                      overflow: hidden;

                      .item-innner-border-left-box {
                        border-bottom: 1px dotted #cccccc;
                        margin-bottom: 6px;
                        width: 10px;
                      }
                    }

                    .item-innner-border-right-box {
                      display: flex;
                      justify-content: space-between;
                      // width: 1209px;
                      align-items: flex-end;

                      .item-innner-text-box {
                        display: flex;
                        cursor: pointer;

                        .item-innner-text-triangle-box {
                          width: 0px;
                          height: 0;
                          border-top: 6px solid transparent;
                          border-right: 6px solid transparent;
                          border-left: 6px solid #aeb2b6;
                          border-bottom: 6px solid transparent;
                          margin-top: 6px;
                          // margin-left: 16px;
                        }

                        .item-innner-text-catalogue-box {
                          margin-left: 10px;
                          width: 208px;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          overflow: hidden;
                        }
                        .inner-text-onview {
                          color: #2d50a1;
                        }
                      }

                      .item-innner-text-right-box {
                        display: flex;
                        width: 82px;
                        justify-content: space-between;
                        align-items: flex-end;
                        margin-left: 33px;

                        .el-icon-video-camera-solid {
                          color: #8f8888;
                          margin-bottom: 4px;
                        }

                        .course-duration {
                          color: #bbbbbb;
                        }
                      }
                    }
                  }
                }
              }

              .el-icon-arrow-right:before {
                content: "+";
                font-size: 15px;
                font-family: "heiti";
                color: #000;
                font-weight: bold;
              }

              .el-collapse-item__arrow.is-active {
                transform: none;
              }

              .el-collapse-item__arrow.is-active::before {
                content: "-";
                font-size: 20px;
                font-family: "heiti";
                color: #000;
                font-weight: 600;
                margin-left: 1px;
              }
            }
          }
        }

        .hidden-to-side {
          right: -420px;
        }
        .normal-show {
          right: 10px;
        }
        .lh-play-box {
          display: block;
          margin-right: 401px;
          position: relative;
          z-index: 49;

          .lh-p-b-title {
            display: block;
            height: 49px;
            padding-top: 20px;
            text-align: center;
            overflow: hidden;

            .left-fl {
              width: 100%;
              float: left;

              .curse-playing {
                display: block;
                height: 34px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 99%;

                .titleByBig {
                  color: #fff;
                  font: 24px / 30px "Hiragino Sans GB", "Microsoft YaHei";
                  vertical-align: middle;
                }
              }
            }
          }
          .video-pr {
            .aside-o-c-btn {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -128px -84px;
              cursor: pointer;
              position: absolute;
              right: 5px;
              top: 48vh;
              height: 108px;
              width: 19px;
              text-align: center;
              overflow: hidden;
            }

            .flash-play-wrap {
              z-index: 33;
              height: 770px;
              margin-right: 21px;
            }

            .turn-raound-show {
              background-image: url(../../assets/publicService/talentService/ioc0905.png);
              background-position: -146px -84px;
              cursor: pointer;
              position: absolute;
              right: 5px;
              top: 48vh;
              height: 108px;
              width: 19px;
              text-align: center;
              overflow: hidden;
            }
          }
        }

        .lh-play-box-show {
          margin-right: 2px !important;
        }
      }
    }

    .lh-umain-show {
      padding: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/onlineCourseVideo.vue